// src/lib/api/userProfileApi.ts
import { getApiClient } from './client';
import { CandidateProfile, CandidateProfileUpdatePayload } from '../models/candidateProfile';
import { ApiError } from 'jasit-api-kit';

const getCandidateProfile = async (): Promise<CandidateProfile | null> => {
    try {
        return await getApiClient().get<CandidateProfile>('/api/profiles');
    } catch (error) {
        // 404 means profile doesn't exist yet — not an error
        if (error instanceof ApiError && error.statusCode === 404) {
            return null;
        }
        throw error;
    }
};

const createCandidateProfile = async (payload: CandidateProfileUpdatePayload): Promise<CandidateProfile> => {
    return getApiClient().post<CandidateProfile>('/api/profiles', payload);
};

const updateCandidateProfile = async (payload: CandidateProfileUpdatePayload): Promise<CandidateProfile> => {
    return getApiClient().put<CandidateProfile>('/api/profiles', payload);
};

const deleteCandidateProfile = async (): Promise<void> => {
    return getApiClient().delete<void>('/api/profiles');
};

export const userProfileApi = {
    getCandidateProfile,
    createCandidateProfile,
    updateCandidateProfile,
    deleteCandidateProfile,
};
